<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="form">
        <v-text-field
          type="password"
          v-model="password"
          :label="$t('profile.current-password')"
          :rules="[
            rules.required,
            rules.passwordLength,
            backEndValidation('password')
          ]"
        ></v-text-field>
        <v-text-field
          v-model="email"
          :label="$t('profile.new-email-address')"
          :rules="[rules.required, rules.email, backEndValidation('email')]"
        ></v-text-field>
      </v-form>
    </v-col>
    <v-col>
      <v-btn color="primary" v-on:click="updateEmail()" :loading="loading">
        <v-icon left>mdi-pencil</v-icon> {{ $t("profile.change-email") }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { rules } from "./../mixins/rules";
export default {
  name: "EditEmail",
  mixins: [rules],
  data: () => ({
    password: "",
    email: "",
    loading: false
  }),
  methods: {
    updateEmail() {
      this.clearBackEndErrors();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch("profileStore/updateEmail", {
            password: this.password,
            email: this.email,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.form.validate();
            })
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style scoped></style>
